export default {
    getAvatar(state) {
        return state.avatar;
    },
    getName(state) {
        return state.name;
    }
}
